import React, { useState } from 'react';

const FAQSection: React.FC = () => {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: "정말 무료인가요?",
      answer: "네, 100% 무료입니다. 숨겨진 비용이나 추가 요금은 전혀 없습니다."
    },
    {
      question: "영상보다 효율적인가요?",
      answer: "30분 → 3분, 10배 효율적입니다. 핵심만 골라서 요약해드리기 때문에 시간을 크게 절약할 수 있습니다."
    },
    {
      question: "영어 몰라도 되나요?",
      answer: "완벽한 한국어 번역을 제공합니다. 영어 실력과 관계없이 모든 내용을 이해할 수 있습니다."
    },
    {
      question: "왜 Reddit인가요?",
      answer: "Reddit은 유튜브보다 빠른 정보를 제공합니다. 실제 개발자들과 전문가들이 실시간으로 소통하는 공간이기 때문입니다."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl font-bold text-center mb-16 text-gray-900">
          자주 묻는 질문
        </h2>
        
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-6 text-left font-semibold text-lg text-gray-900 hover:bg-gray-50 transition-colors duration-200 flex justify-between items-center"
              >
                <span>Q: {faq.question}</span>
                <span className={`transform transition-transform duration-200 ${openFAQ === index ? 'rotate-180' : ''}`}>
                  ▼
                </span>
              </button>
              {openFAQ === index && (
                <div className="px-6 pb-6">
                  <p className="text-gray-600 leading-relaxed">
                    A: {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
